<app-header></app-header>
<div style="display: grid; grid-template-columns: 1fr 1fr">
  <div class="text-center mt-2" >

    <span class="secondButton"><button type="button" (click)="captureScreen()" class="btn btn-primary"><i
          class="fa fa-file-pdf-o" style="font-size:48px;color:#005440"></i></button></span>
  </div>
  <div></div>
</div>
<div id="html2canvas-container"  width="200" height="100" style="margin-top: 10px;margin-right: auto;margin-bottom: auto; margin-left: auto;max-width: 960px; display: grid; grid-template-rows: auto auto;">
  <div style="display: grid; grid-template-columns: 1fr 1fr;">
    <div style="display: grid; grid-template-rows: auto auto;">
      <div class="product-image">
        <img class="img-thumbnail" src="{{baseUrl + specpage[i].productName}}" 
          alt="{{specpage[i].productName}}">
      </div>
    </div>

    <div class="p-4 pb-0 d-flex flex-column">
      <div>
        <span class="firstLabel">Description:</span>
        <span class="secondLabel">{{specpage[i].title}}</span><br /><br />
      </div>
      <label>Features:</label>
      <div style="white-space: pre-wrap" readonly>{{specpage[i].featuresBenefits}}</div>
    </div>
  </div>


<div class ="w3-container">
<div class="row" >
      <div class="table-responsive col-lg-6" >
      <table class="table">
        <tbody>
          <tr class="d-flex">
            <th class="col-5" scope="row">Nomenclature:</th>
            <td class="col-7">{{specpage[i].nomenclature}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Material:</th>
            <td class="col-7">{{specpage[i].material}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Print Group:</th>
            <td class="col-7">{{specpage[i].printGroup}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Title:</th>
            <td class="col-7">{{specpage[i].title}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Size:</th>
            <td class="col-7">{{specpage[i].size}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Lid Color:</th>
            <td class="col-7">{{specpage[i].lidColor}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Cup Height:</th>
            <td class="col-7">{{specpage[i].cupHeight}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Item Dimensions:</th>
            <td class="col-7">{{specpage[i].itemDimensions}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Flush Fill:</th>
            <td class="col-7">{{specpage[i].flushFill}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Practical Fill:</th>
            <td class="col-7">{{specpage[i].practicalFill}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Width At Bottom:</th>
            <td class="col-7">{{specpage[i].widthatBottom}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Width At Rim:</th>
            <td class="col-7">{{specpage[i].widthatRim}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Sleeve Quantity:</th>
            <td class="col-7">{{specpage[i].sleeveQuantity}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-5" scope="row">Sleeves:</th>
            <td class="col-7">{{specpage[i].sleeves}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive col-lg-6">

      <table class="table" >
        <tbody>

          <!-- <tr class="d-flex">
            <th class="col-3" scope="row">Case Pack:</th>
              <td class="col-9">
                <select [model]="i" (change)="SwitchIndex($event)">
                  <option *ngFor="let sp of specpage; index as j" value={{j}}>{{specpage[j].casePack}} </option>
                </select>
            </td>
          </tr> -->
          <tr class="d-flex">
            <th class="col-3" scope="row">Casepack:</th>
            <td class="col-9">{{specpage[i].casePack}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Part:</th>
            <td class="col-9">{{specpage[i].part}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">SCC:</th>
            <td class="col-9">{{specpage[i].scc}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">UPC:</th>
            <td class="col-9">{{specpage[i].upc}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Weight:</th>
            <td class="col-9">{{specpage[i].weight}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Cube:</th>
            <td class="col-9">{{specpage[i].cube}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Length:</th>
            <td class="col-9">{{specpage[i].length}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Height:</th>
            <td class="col-9">{{specpage[i].height}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Width:</th>
            <td class="col-9">{{specpage[i].width}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Pallets:</th>
            <td class="col-9">{{specpage[i].pallets}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Ti:</th>
            <td class="col-9">{{specpage[i].ti}}</td>
          </tr>
          <tr class="d-flex">
            <th class="col-3" scope="row">Hi:</th>
            <td class="col-9">{{specpage[i].hi}}</td>
          </tr>

        </tbody>
      </table>

    </div>

  </div>
</div>
